"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var ReportConflictModalController = /** @class */ (function () {
    function ReportConflictModalController($scope, $window) {
        this.$scope = $scope;
        this.$window = $window;
        $scope.$ctrl = this;
    }
    ReportConflictModalController.prototype.reload = function () {
        this.$window.location.reload();
    };
    ReportConflictModalController.$inject = [
        '$scope',
        '$window'
    ];
    return ReportConflictModalController;
}());
(function (angularModule) {
    angularModule.controller('pr.ReportConflictModalController', ReportConflictModalController);
})(angular_1.default.module('qualtrics.pr'));
